import React, { Component } from "react";
import { Table, Pagination, Col, Row, Input, Select, Button, Tag } from "antd";
import { strings, perPage } from "../../helpers";
import { Link } from "react-router-dom";
const { Option } = Select;

export const newsTypes = ["PHARMA", "CME"];

export default class NewsInterestsView extends Component {
  render() {
    const {
      newsArticleList,
      totalRecords,
      pageNo,
      onPageChange,
      handleFilterNewsType
    } = this.props;
    const columns = [
      {
        title: "Name",
        key: "news_heading",
        align: "left",
        render: record => (
          <div className="news-article-heading">
            {record.source_link ? (
              <a href={record.source_link} target="_blank">
                {record.title}
              </a>
            ) : (
              record.title
            )}
          </div>
        )
      },
      {
        title: "No. of interests",
        align: "left",
        render: record => <div>{record.interest_count}</div>
      },
      {
        title: "Doctor name",
        align: "left",
        render: record => (
          <div>
            {record?.doctors &&
              record.doctors.map((obj, index) => {
                return (
                  <Link
                    to={`/doctor-details/${obj.id}/basic-details`}
                    target="doctor_detail"
                  >
                    {`${obj.name} ${
                      index < record.doctors.length - 1 ? ", " : ""
                    }`}
                  </Link>
                );
              })}
          </div>
        )
      }
    ];

    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col className="heading-domain pl-0" span={12}>
              Interests
            </Col>
            <Col span={6}>
              <label>Filter News Type</label>
              <div>
                <Select
                  defaultValue="PHARMA"
                  style={{ width: "100%" }}
                  onChange={handleFilterNewsType}
                  className="mt-7"
                >
                  {newsTypes.map(obj => {
                    return <Option value={obj}>{obj}</Option>;
                  })}
                </Select>
              </div>
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x">
            <Table
              columns={columns}
              dataSource={newsArticleList}
              pagination={false}
              rowKey="id"
            />
          </div>
        </div>
        <div className="pagination-wrapper">
          {totalRecords > perPage && (
            <div className="total-results-wrap">
              <span className="result-count">{totalRecords}</span>
              {totalRecords > 1 ? strings.results : strings.result}
            </div>
          )}
          {totalRecords > perPage && (
            <Pagination
              total={totalRecords}
              current={pageNo}
              onChange={onPageChange}
              pageSize={perPage}
              defaultCurrent={pageNo}
            />
          )}
        </div>
      </div>
    );
  }
}
